export default __webpack_public_path__ + "static/media/wash-fold-round.13c7ab44.png";